import cx from "classnames"
import * as React from "react"
import * as styles from "./styles.module.scss"
import Link from "gatsby-link"
import BetterLogo from "../BetterLogo"
import BetterLogoMark from "../BetterLogoMark"
import Hamburger from "../Hamburger"
import DropdownRatesPurchase from "../DropdownRatesPurchase"

export interface NavbarCommonProps {
  logomark: boolean
  hideHamburger: boolean
  hideLinks: boolean
  isFlow: boolean
  isNavOpen: boolean
  isScrolled: boolean
  logoLink?: string
  toggleNav: any
}

const NavbarCommon: React.FC<NavbarCommonProps> = ({
  logomark,
  hideHamburger,
  hideLinks,
  isFlow,
  isNavOpen,
  isScrolled,
  logoLink,
  toggleNav,
}) => {
  return (
    <>
      {!hideHamburger && (
        <div className={styles.hamburger}>
          <Hamburger toggleNav={toggleNav} isNavOpen={isNavOpen} />
        </div>
      )}
      <Link to={logoLink ? logoLink : "/"} className={styles.logoBlock}>
        {logomark ? (
          <BetterLogoMark
            className={cx({
              [styles.logo]: true,
              [styles.isScrolled]: isScrolled,
            })}
          />
        ) : (
          <BetterLogo
            className={cx({
              [styles.logo]: true,
              [styles.isScrolled]: isScrolled,
            })}
          />
        )}
      </Link>
      {!hideLinks && (
        <ul className={styles.links}>
          <li className={styles.linkWrap}>
            <DropdownRatesPurchase linkClass={styles.link} />
          </li>
          <li className={styles.linkWrap}>
            <Link
              data-qa="link-to-about-us"
              className={styles.link}
              to="/about-us"
              id="linkto-aboutus"
            >
              <span className={styles.underline}>About Us</span>
            </Link>
          </li>
          <li className={styles.linkWrap}>
            <Link
              to="/content"
              data-qa="link-to-blog"
              className={styles.link}
              id="linkto-blog"
            >
              <span className={styles.underline}>Resources</span>
            </Link>
          </li>
          <li className={styles.linkWrap}>
            <Link
              className={cx({
                [styles.link]: true,
                [styles.linkToFaq]: true,
              })}
              to="/faq"
            >
              <span className={styles.underline}>FAQ</span>
            </Link>
          </li>
        </ul>
      )}
    </>
  )
}

export default NavbarCommon
